export const getAnonymousComplaintList = (payload?: any) => ({
    type: "@saga/GET_ANONYMOUS_COMPLAINT_LIST",
    payload
});

